import { useTheme } from "@material-ui/core";
import { ImgHTMLAttributes } from "react";
import logo from "./uselemon.jpeg";

export default function DiggerLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
  const darkMode = useTheme().palette.type === "dark";
  return (
    <>
      <img
        {...props}
        src={logo}
        alt="logo"
        style={{
          filter: darkMode ? "invert(1) saturate(0)" : "none",
          maxWidth: "60px",
          marginRight: "10px",
          position: "relative",
          top: "2px",
        }}
      />
    </>
  );
}
